export default __webpack_public_path__ + "static/media/NA.46860825.svg";